
//#region src/lib/isInternalURL.ts
/**
* Determines if a URL is internal or external.
*
* @param url - The URL to check if internal or external.
*
* @returns `true` if `url` is internal, `false` otherwise.
*/
const isInternalURL = (url) => {
	const isInternal = /^(\/(?!\/)|#)/.test(url);
	const isSpecialLink = !isInternal && !/^https?:\/\//.test(url);
	return isInternal && !isSpecialLink;
};

//#endregion
exports.isInternalURL = isInternalURL;
//# sourceMappingURL=isInternalURL.cjs.map